import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components';
import toast from 'react-hot-toast';
import moment from 'moment';
import Api from '../utils/Api';
import ListCard from '../components/ListCard';
import GroupCard from '../components/GroupCard';
import ItemList from '../components/ItemList';
import Loading from '../components/Loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCopy,
} from '@fortawesome/free-solid-svg-icons';
const inviteStyles = css`
display: flex;
width: 100%;
align-items: center;
justify-content: space-between;
padding: 10px;
 > .user {
 }
 > .copy {
 }
`
const InvitationCard = styled(({ className, item }) => {
  const inviteUrl = `${item.clientUrl}/${item._id}`;
  const copyLink = (url) => {
    navigator.clipboard.writeText(url);
    toast.success('Invitation Link Copied')
  };
  const invitedTo = item.list ? `list "${item.list.name}"` : `group "${item.group?.name}"`;

  return (
    <div className={className}>
      <div className='user'>
        <div>{`${item.firstname} ${item.lastname}`}</div>
        <div>{`${item.email}`}</div>
        <div>{`Invited to ${invitedTo}`}</div>
        <div>
          {`Expires on ${moment(item.expiresAt).format('MM-DD-YYYY HH:mm:ss')}`}
        </div>
      </div>
      <div className='copy'>
        <button className='primary' onClick={() => copyLink(inviteUrl)}>
          <FontAwesomeIcon icon={faCopy} />
        </button>
      </div>
    </div>
  )
})`${inviteStyles}`;

const appCss = css`
width: 100%;
display: grid;
flex-wrap: wrap;
justify-content: center;
grid-template-columns: repeat(auto-fit, minmax(250px, 500px));
column-gap: 20px;
row-gap: 20px;

& .section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: left;
  flex-grow: 1;

  & .title {
    display: flex;
    gap: 20px;
    text-align: left;
    border-bottom: 1px solid gray;
    padding-left: 10px;
    padding-bottom: 5px;
    font-weight: bold;
    align-items: center;
    justify-content:space-between;

    > .button {
      margin-right: 20px;
    }
  }

  > .button {
    display: flex;
    gap: 10px;
    color: white;
    font-size: 0.8em;
  }

  > .invitation {
    display: flex;
  }
}
`;

const Dashboard = styled(({ className }) => {

  const navigate = useNavigate();
  const { isLoading: loading1, data: [error1, myLists] = [] } = useQuery(["my-lists"], async () => await Api.getMyLists());
  const { isLoading: loading2, data: [error2, friendsLists] = [] } = useQuery(["friends-lists"], async () => await Api.getFriendsLists());
  const { isLoading: loading3, data: [error3, myGroups] = [] } = useQuery(["my-groups"], async () => await Api.getMyGroups());
  const { isLoading: loading4, data: [error4, friendsGroups] = [] } = useQuery(["friends-groups"], async () => await Api.getFriendsGroups());
  const { isLoading: loading5, data: [, invitations] = [] } = useQuery(["invitations"], async () => await Api.getMyInvitations());

  const error = error1 || error2 || error3 || error4;
  if (error) toast.error(Api.error(error));

  return (
    <div className={className}>
      <div className='section'>
        <div className='title'>
          <div>Lists I've Created</div>
          <div className='button'>
            <button className='primary' title='Create A List' onClick={() => navigate('/lists/new')}>
              <span>Create A List</span>
            </button>
          </div>
        </div>
        <Loading isLoading={loading1}>
          <ItemList
            items={myLists ?? []}
            component={ListCard}
            emptyText={"You haven't created any lists yet"}
            onSelectItem={list => navigate(`/lists/details/${list._id}`)} />
        </Loading>
      </div>
      <div className='section'>
        <div className='title'>
          <div>Groups I've Created</div>
          <div className='button'>
            <button className='primary' title='Create A group' onClick={() => navigate('/groups/new')}>
              <span>Create A Group</span>
            </button>
          </div>
        </div>
        <Loading isLoading={loading2}>
          <ItemList
            items={myGroups ?? []}
            component={GroupCard}
            emptyText={"You haven't created any groups yet"}
            onSelectItem={group => navigate(`/groups/details/${group._id}`)} />
        </Loading>
      </div>
      <div className='section'>
        <div className='title'>
          <div>Lists Shared With Me</div>
        </div>
        <Loading isLoading={loading3}>
          <ItemList
            items={friendsLists?.userLists ?? []}
            component={ListCard}
            emptyText={"Nobody has shared any lists with you yet"}
            onSelectItem={list => navigate(`/lists/details/${list._id}`)} />
        </Loading>
      </div>
      <div className='section'>
        <div className='title'>
          <div>Groups Shared With Me</div>
        </div>
        <Loading isLoading={loading4}>
          <ItemList
            items={friendsGroups ?? []}
            component={GroupCard}
            emptyText={"You haven't joined any groups yet"}
            onSelectItem={group => navigate(`/groups/details/${group._id}`)} />
        </Loading>
      </div>
      <div className='section'>
        <div className='title'>
          <div>Invitations You've Sent (Pending)</div>
        </div>
        <Loading isLoading={loading5}>
          <ItemList
            items={invitations ?? []}
            component={InvitationCard}
            emptyText={"You have no pending invitations"}
            onSelectItem={group => navigate(`/groups/details/${group._id}`)} />
        </Loading>
      </div>
    </div>
  )
})`${appCss}`;

export default Dashboard;
